import AcceptCandidateModal from './AcceptCandidateModal.component';

export default AcceptCandidateModal;
